var t=n=>{throw typeof n=="string"?new Error(n):n};export{t as raise};
//# sourceMappingURL=main.js.map